export default __webpack_public_path__ + "static/media/payment-success.05eaa53b.png";